import { useQuery } from 'react-query';
import { useContext } from 'react';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { AppContext } from 'views/App/context';

import type { AccreditationStandardList } from '../../../_types/awb';

export const fetchAccreditationStandards = async (
  orgId: string,
  accreditationBodyId: string,
  versionId: string,
  useRUIData = false
) => {
  // Use non-org-specific API when awbRUIData feature is enabled
  const url = useRUIData
    ? `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationBodyId}/versions/${versionId}/standards`
    : `${baseApiUrl()}/awb/accreditation-body/v1/organizations/${orgId}/accreditation-bodies/${accreditationBodyId}/versions/${versionId}/standards`;

  const data = await fetcher({
    method: 'get',
    url,
  });
  return data.sort((a: AccreditationStandardList, b: AccreditationStandardList) => a.position - b.position);
};

export default function useAccreditationStandards(
  orgId: string,
  accreditationBodyId: string,
  versionId: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const { isFeatureEnabled } = useContext(AppContext);
  const useRUIData = isFeatureEnabled('awbRUIData') || isFeatureEnabled('awbPremiumDemo');

  return useQuery<AccreditationStandardList[], Error>(
    ['accreditation_standards', orgId, accreditationBodyId, versionId, useRUIData],
    () => fetchAccreditationStandards(orgId, accreditationBodyId, versionId, useRUIData),
    {
      enabled: !!versionId,
      staleTime: 900000, // 15 minutes in milliseconds
      ...options,
    }
  );
}
